import composition from "rfuncs/functions/composition"
import last from "rfuncs/functions/last"

import split_filename from "./split_filename"

export default composition(split_filename, last) as (filename: string) => string
